import { CheckMobileCodeModel, SendMobileCodeModel } from './../model/check-mobile-code.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.services';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { MemberJoinModel } from '../model/member-join.model';

@Injectable()
export class LeadService extends BaseService {

  constructor(private http: HttpClient,
    public toastr: ToastrService) {
    super(toastr);
  }

  checkMobileCode(obj: CheckMobileCodeModel): Observable<any> {
    return this.http.post<CheckMobileCodeModel>(environment.apiUrl + `/Lead/check-mobile-code`, obj, { headers: this.headers() });
  }

  sendMobileCode(obj: SendMobileCodeModel): Observable<any> {
    return this.http.post<SendMobileCodeModel>(environment.apiUrl + `/Lead/send-mobile-code`, obj, { headers: this.headers() });
  }

  update(step: number, field: string, obj: MemberJoinModel): Observable<any> {
    return this.http.put<MemberJoinModel>(environment.apiUrl + `/Lead/step/${step}/field/${field}/update`, obj, { headers: this.headers() });
  }

  complete(obj: MemberJoinModel): Observable<any> {
    return this.http.post<MemberJoinModel>(environment.apiUrl + `/Lead/complete`, obj, { headers: this.headers() });
  }

  createLead(obj: MemberJoinModel): Observable<any> {
    return this.http.post<MemberJoinModel>(environment.apiUrl + `/Lead/create-lead`, obj);
  }

  addLeadWorkflowMetric(step:number): Observable<any> {
    return this.http.post(environment.apiUrl + `/Lead/step/${step}`, {}, { headers: this.headers() });
  }
}
